import { render } from "./GroupBasicProductFields.vue?vue&type=template&id=90b09536&scoped=true"
import script from "./GroupBasicProductFields.vue?vue&type=script&lang=js"
export * from "./GroupBasicProductFields.vue?vue&type=script&lang=js"

import "./GroupBasicProductFields.vue?vue&type=style&index=0&id=90b09536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b09536"]])

export default __exports__